// Registry de todos los posts del blog
// Importar cada post individual
import mejorHerramientaAutomatizarMensajes from './mejor-herramienta-automatizar-mensajes';
import diferenciasWhatsapp from './diferencias-whatsapp-personal-business-api-coexistencia';
import evitarSancionesWhatsapp from './evitar-sanciones-whatsapp-empresa';
import comoAutomatizarWhatsapp from './como-automatizar-whatsapp';
import whatsappCoexistencia from './whatsapp-coexistencia-que-es-como-funciona';
import comoVenderMasWhatsappRedes from './como-vender-mas-whatsapp-redes-sociales';
import seguimientosVentasOnline from './seguimientos-ventas-online-maximiza-conversiones';

// Array con todos los posts ordenados por fecha (más reciente primero)
export const blogPosts = [
  seguimientosVentasOnline,
  comoVenderMasWhatsappRedes,
  whatsappCoexistencia,
  comoAutomatizarWhatsapp,
  evitarSancionesWhatsapp,
  diferenciasWhatsapp,
  mejorHerramientaAutomatizarMensajes,
  // Futuros posts se agregarán aquí
];

// Función helper para obtener un post por slug
export const getPostBySlug = (slug) => {
  return blogPosts.find(post => post.slug === slug);
};

// Función helper para obtener posts por categoría
export const getPostsByCategory = (category) => {
  return blogPosts.filter(post => post.category === category);
};

// Función helper para obtener posts destacados
export const getFeaturedPosts = () => {
  return blogPosts.filter(post => post.featured);
};

// Función helper para obtener todas las categorías únicas
export const getAllCategories = () => {
  const categories = blogPosts.map(post => post.category);
  return [...new Set(categories)];
};

// Función helper para obtener todos los tags únicos
export const getAllTags = () => {
  const tags = blogPosts.flatMap(post => post.tags);
  return [...new Set(tags)];
};

export default blogPosts;
